import React from "react";
import { Link } from "react-router-dom";
import styles from "./MainCMS.module.css";
import homepageImage from "../../Assets/background.jpg";

const Homepage = () => {
  return (
    <div
      className={styles.container}
      style={{ backgroundImage: `url(${homepageImage})` }}
    >
      <div className={styles.containerContent}>
        <h1 className={styles.header}>Welcome to Ogawa CMS</h1>
        <div className={styles.buttonContainer}>
          <Link to="/bodyfriend-cms">
            <button className={styles.button}>BodyFriend</button>
          </Link>

          <button
            className={styles.button}
            onClick={() => alert("Fujitech Clicked!")}
          >
            Fujitec
          </button>
        </div>
      </div>
    </div>
  );
};

export default Homepage;
